"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedCookieDomain = sharedCookieDomain;
exports.isVercelAlias = isVercelAlias;
const SHARED_COOKIE_DOMAINS = [
    "newform.com",
    "newform.ai",
    "newformstaging.com",
];
/**
 * The parent domain a sign-in cookie is shared across for a hostname, so the
 * app and the API on the same site both receive it, or undefined where the
 * cookie stays on that one host (localhost, Vercel previews, personal staging
 * on the hosting platform's generated domains).
 */
function sharedCookieDomain(hostname) {
    if (!hostname)
        return undefined;
    return SHARED_COOKIE_DOMAINS.find((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
}
/**
 * A Vercel deployment or branch alias, where a personal staging slot's app
 * lives. Report Lab signs in beside one by handoff, never by shared cookie.
 */
function isVercelAlias(hostname) {
    return !!hostname && hostname.endsWith(".vercel.app");
}
